<script lang="ts">
	// svelte
	import { fly } from 'svelte/transition';

	// components
	import Button from '$components/utilities/Button.svelte';

	// lib
	import toastStore from '$stores/toast';

	// icons
	import CheckmarkFilled from 'carbon-icons-svelte/lib/CheckmarkFilled.svelte';
	import Close from 'carbon-icons-svelte/lib/Close.svelte';
	import ErrorFilled from 'carbon-icons-svelte/lib/ErrorFilled.svelte';
	import InformationFilled from 'carbon-icons-svelte/lib/InformationFilled.svelte';

	// types
	import type { DateTime } from 'luxon';

	// * required props *
	export let id: string;
	export let createdAt: DateTime;
	export let description: string;
	export let title: string;

	// optional props
	export let kind: 'success' | 'info' | 'error' = 'info';
</script>

<li
	class="shadow-stack flex w-80 max-w-full items-start justify-between border-2 border-t-4 border-zinc-700 bg-zinc-900 p-3"
	transition:fly|local
>
	<div class="flex w-4/5 items-start">
		{#if kind === 'error'}
			<ErrorFilled class="mt-1 flex-none text-red-500" size={20} />
		{:else if kind === 'info'}
			<InformationFilled class="mt-1 flex-none text-yellow-500" size={20} />
		{:else}
			<CheckmarkFilled class="mt-1 flex-none text-green-300" size={20} />
		{/if}
		<div class="ml-3">
			<header>
				<h3 class="mono text-sm font-semibold">
					{title}
				</h3>
				<p class="mt-1.5 break-words text-zinc-300">
					{description}
				</p>
			</header>
			<div class="mt-3">
				<slot name="action" />
			</div>
			<p class="mt-1.5 text-sm text-zinc-300">
				<time datetime={createdAt.toString()}>{createdAt.toFormat('tt')}</time>
			</p>
		</div>
	</div>
	<div class="flex w-1/5 justify-end">
		<Button
			icon={Close}
			kind="ghost"
			onClick={() => toastStore.deleteNotification(id)}
			size="sm"
			title="Close"
			tooltipAlignment="end"
			type="icon"
		/>
	</div>
</li>
